var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('l-table',{ref:"LTable",attrs:{"module-name":_vm.MODULE_NAME,"table-columns":_vm.tableColumns,"filter-class":_vm.filterClass},scopedSlots:_vm._u([{key:"cell(dc_type)",fn:function(ref){
var data = ref.data;
return [_vm._v(" "+_vm._s(_vm.$langName(_vm.getDcType(data.value).name))+" ")]}},{key:"cell(user)",fn:function(ref){
var data = ref.data;
return [_vm._v(" "+_vm._s(data.value.full_name)+" ")]}},{key:"cell(period)",fn:function(ref){
var data = ref.data;
return [_vm._v(" "+_vm._s(data.item.period + '/' +data.item.quarter)+" ")]}},{key:"cell(organization)",fn:function(ref){
var data = ref.data;
return [_vm._v(" "+_vm._s(_vm.$langName(data.value))+" ")]}},{key:"cell(direction_name)",fn:function(ref){
var data = ref.data;
return [_vm._v(" "+_vm._s(data.item.direction_code + ' - ' + _vm.$langName(data.value))+" ")]}},{key:"cell(is_certificate)",fn:function(ref){
var data = ref.data;
return [_c('b-badge',{attrs:{"variant":data.value ? 'success': 'danger'}},[_vm._v(" "+_vm._s(_vm.$t(data.value ? 'Yes': 'No'))+" ")])]}},{key:"cell(is_accepted)",fn:function(ref){
var data = ref.data;
return [_c('b-badge',{attrs:{"variant":_vm.getExamResultColor(data.value)}},[_vm._v(" "+_vm._s(_vm.$langName(_vm.getExamResultStatus(data.value).name))+" ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }